<template>
  <div class="main-container">
    <div>
      <v-layout wrap>

        <v-flex md2 sm12 style="padding-right: 20px">
          <choose-date clearable :label="$t('common.from')" v-model="from"></choose-date>
        </v-flex>
        <v-flex md2 sm12 style="padding-right: 20px">
          <choose-date clearable :label="$t('common.to')" v-model="to"></choose-date>
        </v-flex>
        <v-flex md2 sm12>
          <v-select item-text="text" :items="[{ text: $t('common.all'), value: 'All' }, { text: $t('drivers.shiftLogsAvg.normal'), value: 'Normal' }, { text: $t('drivers.shiftLogsAvg.seasonal'), value: 'Seasonal' }, { text: $t('drivers.shiftLogsAvg.specific'), value: 'Specific' }]" v-model="driver_type"
            :label="$t('drivers.shiftLogsAvg.driverType')"></v-select>
        </v-flex>
        <v-flex md2 sm12 v-if="driver_type == 'Specific'">
          <v-autocomplete v-model="selectedCaptain" clearable dense :items="captains" :loading="captainLoading"
            :search-input.sync="searchCaptainParam" :label="$t('drivers.shiftLogsAvg.captain')" item-text="text" item-value="id"
            :placeholder="$t('drivers.shiftLogsAvg.searchForCaptain')" no-filter :debounce-search="250"><template slot="item"
              slot-scope="captains">
              <v-list-tile-content>
                <v-list-tile-title :style="captains.item.deleted_at ? { color: 'red' } : {}" v-html="captains.item.first_name +
                  ' ' +
                  captains.item.last_name
                  "></v-list-tile-title>
                <v-list-tile-sub-title :style="captains.item.deleted_at ? { color: 'red' } : {}" v-html="captains.item.username"></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex md2 sm12>
          <v-btn color="primary" dark class="mb-2 cbtn" @click="filter()" :loading="diaload">{{ $t("drivers.shiftLogsAvg.getData") }}</v-btn>
        </v-flex>
      </v-layout>
    </div>


    <div style="overflow-x: auto; white-space: nowrap;">
      <table class="noselect">
        <tr>

          <th v-for="(_hour, index) in 24" :key="index">
            {{ index }}:00 - {{ index == 23 ? 0 : index + 1 }}:00
          </th>
        </tr>
        <tr>

          <td v-for="(_hour, index) in 24" :key="index">
            <span>{{ getActiveUsers(index) }} </span>
          </td>
        </tr>
      </table>
    </div>
    <v-dialog v-model="diaload" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("drivers.shiftLogsAvg.loadingData") }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import api from "@/constants/api";
import ChooseDate from "@/components/monaco/input/ChooseDate";

export default {
  name: "ShiftLogsAvg",
  components: { ChooseDate },
  data: () => ({
    driver_type: "All",
    selectedCaptain: null,
    searchCaptainParam: "",
    captains: [],
    captainLoading: false,
    shifts: [],
    sortedShifts: [],
    activeArray: ['Offline', 'Online'],
    from: null,
    to: null,
    diaload: false,
  }),
  watch: {


  },
  mounted() {
    this.from = moment().format("YYYY-MM-DD");
    this.to = moment().format("YYYY-MM-DD");
  },
  watch: {
    searchCaptainParam() {
      this.getCaptains();
    }

  },
  methods: {
    getCaptains() {
      if (!this.searchCaptainParam) {
        return;
      }
      this.captainLoading = true;
      const params = new URLSearchParams();
      params.append("search", this.searchCaptainParam);
      params.append("trashed", 1);
      this.axios
        .get(`captain/search`, { params })
        .then((res) => {
          this.captains = res.data.data.map((captain) => ({
            text:
              `${captain.full_name || ""}` + " " + `${captain.username || ""}`,
            ...captain,
          }));
        })
        .finally(() => {
          this.captainLoading = false;
        });
    },
    filter() {
      if (moment(this.from).isAfter(moment(this.to))) {
        window.getApp.$emit("SHOW_TOAST", this.$t("drivers.shiftLogsAvg.datesInvalid"), 'red');
        return;
      }
      this.diaload = true;
      this.shifts = [];

      const params = new URLSearchParams();
      params.append('from', moment(this.from).format("YYYY-MM-DD"));
      params.append('to', moment(this.to).format("YYYY-MM-DD"));
      params.append("driver_type", this.driver_type);
      if (this.selectedCaptain)
        params.append("selected_captain", this.selectedCaptain);
      axios
        .get(this.api.ACTIONS.CAPTAIN_SHIFT_LOGS_AVG, { params })
        .then((res) => {
          this.shifts = res.data.data
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("drivers.shiftLogsAvg.errorTryLater"), 'red');

          console.log(err);
        })
        .finally(() => {
          this.diaload = false;
        });
    },
    getActiveUsers(index) {
      let res = this.shifts.find(a => a.hour == index);

      return res ? res.active_users : "0.00";
    }
  },


};
</script>

<style lang="scss" scoped>
.main-container {
  float: left;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 18px 25px;
  gap: 20px;

  .statuses {
    width: auto;
    height: 42px;
    float: left;
    display: flex;
    flex-direction: row;
    gap: 10px;

    .status {
      padding: 13px 18px;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      float: left;
      color: white;
      border-radius: 9999px;
    }
  }



  table {
    width: 100%;
    height: auto;
    float: left;
    background: white;
    padding: 0;
    border-radius: 10px;
    box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.1);
    // table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;

    td,
    th,
    tr {
      border: 1px solid #c1c5d8;
      height: 45px;
      // overflow: hidden;

      .current-time-indicator {
        top: 0;
        width: 2px;
        background: #e10015;
        height: 100%;
        position: absolute;
        z-index: 18;
      }
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 10px !important;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 10px !important;
    }

    tr:first-child th:last-child {
      border-top-right-radius: 10px !important;
    }

    tr:first-child th:first-child {
      border-top-left-radius: 10px !important;
    }

    tr:nth-child(even) {
      background-color: #f7f8fa;
    }

    td,
    th {
      padding: 14px;
      padding-left: 16px;
    }

    .driver-name {
      width: 13%;
      max-width: 142px;
      min-width: 100px;
      padding: 16px;
      text-align: left;
    }

    .taxi-number {
      width: 10%;
      padding: 16px;
      max-width: 142px;
      text-align: left;
    }

    .timing-container {
      width: 100%;
      height: 100%;
      max-width: 100%;
      position: relative;
      overflow-x: overlay;

      .status {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        height: 12px;
        border-radius: 9999px;
        z-index: 8;
        cursor: pointer;
        transition: 0.2s;

        &.end {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
      }

      .times {
        width: max-content;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;

        .time {
          width: 184px;
          height: 100%;
          float: left;
          padding: 16px 22px;
          text-align: left;
          position: relative;

          .half-hour-divider {
            height: 10px;
            width: 1px;
            background: #c1c5d8;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }

          &:not(:last-child) {
            border-right: 1px solid #c1c5d8;
          }
        }
      }

      &::-webkit-scrollbar {
        width: 0em;
        height: 0em;
      }
    }

    .noOrders {
      p {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>